<app-header (clickMenu)="drawer.toggle()"></app-header>

<mat-drawer-container>
  <mat-drawer #drawer class="sidenav-contaienr" mode="side">
    <app-filter></app-filter>
  </mat-drawer>

  <div class="sidenav-content">
    <app-employee-list></app-employee-list>
  </div>
</mat-drawer-container>